// extracted by mini-css-extract-plugin
export default {"root":"_2nB7k","line":"_33baU","text":"_1PkJN"};